// extracted by mini-css-extract-plugin
module.exports = {"myVideo":"LocalPreview_myVideo__2qLhk","myVideoHidden":"LocalPreview_myVideoHidden__3PbpJ"};